import { Result } from 'components/searchAndFilter';
import React from 'react';

interface Props {
  columns: { [columnName: string]: boolean };
  columnOrder: string[];
  customSelectionChange?: (rowIndices: number[]) => void;
}
const ViewTableContainer = (props: Props) => {
  const { columns, columnOrder, customSelectionChange } = props;
  const getColumnNames = () => {
    return columnOrder.filter((columnName) => columns[columnName] === true);
  };

  return (
    <div
      id="searchandfilter-table-viewtablecontainer-wrapper"
      className="pt-[4px] pb-[4px] pl-[4px] pr-[4px] h-[84vh]"
    >
      <Result
        columnsToDisplay={getColumnNames()}
        showPaginator={false}
        customSelectionChange={customSelectionChange}
      />
    </div>
  );
};

export default ViewTableContainer;
